import { Grid, Typography, useTheme, Box } from "@mui/material";
import { capitalize } from "lodash";
import { useTranslation } from "react-i18next";
import { memo } from "react";
import {
  ColumnVisibility,
  getColumnSizes,
  THUMBNAIL_WIDTH_PX,
  ACTIONS_WIDTH_PX,
} from "./projectListColumnWidths";

type Props = {
  visibleColumns: ColumnVisibility;
};

const ProjectListTableHeader = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const sizes = getColumnSizes(props.visibleColumns);

  const headerStyle = {
    backgroundColor: theme.palette.mode === "dark" ? "#121212" : "#fff",
    borderBottom: `2px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`,
    borderRadius: "8px 8px 0 0",
    width: "100%",
  };

  const textStyle = {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.mode === "dark" ? "#FFFFFF" : "#333333",
    letterSpacing: "0.5px",
  };

  return (
    <Box
      sx={{
        margin: "0 0 8px 0",
        ...headerStyle,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "12px 4px",
          minHeight: 56,
        }}
      >
        <Box sx={{ flex: `0 0 ${THUMBNAIL_WIDTH_PX}px`, width: 40 }} />

        <Grid container columns={sizes.total} sx={{ flex: 1 }}>
          {/* Project Name */}
          {props.visibleColumns.showName && (
            <Grid item xs={sizes.name}>
              <Typography
                sx={{ ...textStyle, textAlign: "left", paddingLeft: "10px" }}
              >
                {capitalize(t("NAME"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showJobsite && (
            <Grid item xs={sizes.jobsite}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("JOBSITE_NAME_HEADER"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showPhotographer && (
            <Grid item xs={sizes.photographer}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("PHOTOGRAPHER"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showType && (
            <Grid item xs={sizes.type}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("TYPE"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showCaptureDate && (
            <Grid item xs={sizes.captureDate}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("CAPTURED_DATE"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showUploadDate && (
            <Grid item xs={sizes.uploadDate}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("UPLOAD_DATE"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showImages && (
            <Grid item xs={sizes.images}>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>
                {capitalize(t("IMAGES"))}
              </Typography>
            </Grid>
          )}

          {props.visibleColumns.showStatus && (
            <Grid item xs={sizes.status}>
              <Typography sx={{ ...textStyle, textAlign: "left" }}>
                {capitalize(t("STATUS"))}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Box sx={{ flex: `0 0 ${ACTIONS_WIDTH_PX}px`, width: 24 }} />
      </Box>
    </Box>
  );
};
export default memo(ProjectListTableHeader);
